import { Outlet } from "react-router-dom";

export default function HerLayout() {
    return(
        <>
            <div className="body her-bg">
                <Outlet />
            </div>

            <div class='fixed-bottom text-center w-100 text-bg-light fw-bold her-font fs-4 rounded-top'>coded with love by kevi 💛</div>
        </>
    );
}